import { IEnquirySummary } from "@/models/interfaces/enquiry/enquiry-summary.model.interface";

export class EnquirySummary implements IEnquirySummary {
    public enquiries: number;
    public conversions: number;
    public revenue: number;

    constructor() {
        this.enquiries = 0;
        this.conversions = 0;
        this.revenue = 0;
    }
}
